import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import { fetchUser } from './store/auth-store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Wrapper component to defer fetchUser until after initial render
const AppWithDeferredAuth: React.FC = () => {
  useEffect(() => {
    // Defer auth check to not block initial paint
    const token = localStorage.getItem('token');
    if (token) {
      store.dispatch(fetchUser());
    }
  }, []);

  return <App />;
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppWithDeferredAuth />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('kokki-service-worker-update', { detail: registration }));
  },
});
